import React from 'react';
import styled from "styled-components";
import {colors} from "../maps/colors";
import dayjs from "dayjs";


const WrapperStyled = styled.div`
  position: absolute;
  border-radius: 50%;
  outline: 1px solid #b5b5b5;
  outline-offset: 0;
`;
const SensorStatus = ({status, size = 5, statusUpdateAt}) => {
    const style = {
        width: size,
        height: size,
        background: colors.LIME,
        top: size / 2,
        right: size / 2
    };

    let statusTitle = "Online";
    let since = "Unknown";


    if (status === undefined) {
        statusTitle = "Unknown";
        style.background = colors.GRAY4;
    }
    if (status === false) {
        statusTitle = "Offline";
        style.background = colors.RED1;
    }

    if (statusUpdateAt) {
        since = dayjs(statusUpdateAt).format("H:mm, M YYYY");
    }

    const title = `Status: ${statusTitle}, since: ${since}`;

    return (
        <WrapperStyled style={style} title={title}/>
    );
};

export default SensorStatus;